import { Navigate, useRoutes } from 'react-router-dom';
// layouts
import DashboardLayout from './layouts/dashboard';
import SimpleLayout from './layouts/simple';
//
import LeadsPage from './pages/LeadsPage';
import LoginPage from './pages/LoginPage';
import Page404 from './pages/Page404';
import DashboardAppPage from './pages/DashboardAppPage';
import ProjectsPage from './pages/ProjectsPage';
import SalesDashboardPage from './pages/SalesDashboardPage';
import ServiceDashboardPage from './pages/ServiceDashboardPage';
import SEO from './pages/Service/SEO';
import ContentCreation from './pages/Service/ContentCreation';
import WebsiteTeam from './pages/Service/WebsiteTeam';
import CameraTeam from './pages/Service/CameraTeam';
import EditingTeam from './pages/Service/EditingTeam';
import UserPage from './pages/UserPage';
import ServiceDashboard from './pages/ServiceDashboard';
import SalesDashboard from './pages/SalesDashboard';
import GraphicDesign from './pages/Service/GraphicDesign';
import ConvertedLeads from './pages/ConvertedLeads';
import SocialMediaHandler from './pages/Service/SocialMediaHandler';
import OnGoingTasks from './pages/Service/OverallTasks';
import Account from './pages/Account';
import SelfAssignedLeads from './pages/SelfAssignedLeads';
import ScheduledAppointments from './pages/ScheduledAppointments';
import UnderFollowUpLeads from './pages/UnderFollowUpLeads';
import ViewDetails from './pages/ViewDetails';
import SelfAssignedWebsite from './pages/SelfAssigned/SelfAssignedWedsite';
import SeoSelfAssigned from './pages/SelfAssigned/SeoSelfAssigned';
import GraphicSelfAssigned from './pages/SelfAssigned/GraphicSelfAssigned';
import ContentCreationSelfAssigned from './pages/SelfAssigned/ContentCreationSelfAssigned';
import CameraManSelfAssigned from './pages/SelfAssigned/CameraManSelfAssigned';
import VideoEditingSelfAssigned from './pages/SelfAssigned/VideoEditingSelfAssigned';
import SocialMediaSelfAssigned from './pages/SelfAssigned/SocialMediaSelfAssigned';
// ----------------------------------------------------------------------

export default function Router() {

  const role = sessionStorage.getItem("role");
  const serviceTeamType = sessionStorage.getItem("serviceTeamType");
  console.log("User Role:", role);
  console.log("Team Type:", serviceTeamType)


  const routes = useRoutes([
    {
      path: '/admin',
      element: role === "Admin" ? <DashboardLayout /> : <Navigate to="/404" />,
      children: [
        { path: 'dashboard/app', element: <DashboardAppPage /> },
        { path: 'dashboard/users', element: <UserPage /> },
        { path: 'dashboard/projects', element: <ProjectsPage /> },
        { path: 'dashboard/leads', element: <LeadsPage /> },
        { path: 'dashboard/sales-dashboard', element: <SalesDashboardPage /> },
        { path: 'dashboard/scheduled-appointments', element: <ScheduledAppointments /> },
        { path: 'dashboard/under-follow-ups', element: <UnderFollowUpLeads /> },
        { path: 'dashboard/converted-leads', element: <ConvertedLeads /> },
        { path: 'view-details/:id', element: <ViewDetails /> },
        { path: 'dashboard/service-dashboard', element: <ServiceDashboardPage /> },
        { path: 'dashboard/seo-team', element: <SEO /> },
        { path: 'dashboard/content-creation-team', element: <ContentCreation /> },
        { path: 'dashboard/website-team', element: <WebsiteTeam /> },
        { path: 'dashboard/camera-team', element: <CameraTeam /> },
        { path: 'dashboard/editing-team', element: <EditingTeam /> },
        { path: 'dashboard/graphic-design-team', element: <GraphicDesign /> },
        { path: 'dashboard/social-media-handler-team', element: <SocialMediaHandler /> },
        { path: 'dashboard/account', element: <Account /> }
      ],
    },
    {
      path: '/sales',
      element: role === "Sales" ? <DashboardLayout /> : <Navigate to="/404" />,
      children: [
        { path: 'dashboard/app', element: <SalesDashboard /> },
        { path: 'dashboard/leads', element: <LeadsPage /> },
        { path: 'dashboard/sales-dashboard', element: <SalesDashboardPage /> },
        { path: 'dashboard/converted-leads', element: <ConvertedLeads /> },
        { path: 'dashboard/self-assigned-leads', element: <SelfAssignedLeads /> },
        { path: 'dashboard/scheduled-appointments', element: <ScheduledAppointments /> },
        { path: 'dashboard/under-follow-ups', element: <UnderFollowUpLeads /> },
        { path: 'dashboard/account', element: <Account /> }
      ],
    },
    {
      path: '/service',
      element: role === "Service" ? <DashboardLayout /> : <Navigate to="/404" />,
      children: [
        { path: 'dashboard/app', element: <ServiceDashboard /> },
        { path: 'dashboard/service-dashboard', element: <ServiceDashboardPage /> },
        { path: 'dashboard/seo-team', element: <SEO /> },
        { path: 'dashboard/content-creation-team', element: <ContentCreation /> },
        { path: 'dashboard/website-team', element: <WebsiteTeam /> },
        { path: 'dashboard/camera-team', element: <CameraTeam /> },
        { path: 'dashboard/editing-team', element: <EditingTeam /> },
        { path: 'dashboard/graphic-design-team', element: <GraphicDesign /> },
        { path: 'dashboard/social-media-handler-team', element: <SocialMediaHandler /> },
        { path: `dashboard/${serviceTeamType?.toLowerCase().replace(/\s+/g, "-") || "default"}/overall-tasks`, element: <OnGoingTasks /> },
        { path: 'dashboard/account', element: <Account /> },
        { path: 'dashboard/website-self-assigned', element: <SelfAssignedWebsite /> },
        { path: 'dashboard/seo-self-assigned', element: <SeoSelfAssigned /> },
        { path: 'dashboard/graphic-self-assigned', element: <GraphicSelfAssigned /> },
        { path: 'dashboard/content-creation-self-assigned', element: <ContentCreationSelfAssigned /> },
        { path: 'dashboard/camera-self-assigned', element: <CameraManSelfAssigned /> },
        { path: 'dashboard/video-editing-self-assigned', element: <VideoEditingSelfAssigned /> },
        { path: 'dashboard/social-media-self-assigned', element: <SocialMediaSelfAssigned /> },
      ],
    },
    {
      path: 'login',
      element: <LoginPage />,
    },
    {
      element: <SimpleLayout />,
      children: [
        { element: <Navigate to="/login" />, index: true },
        { path: '404', element: <Page404 /> },
        { path: '*', element: <Navigate to="/404" /> },
      ],
    },
    {
      path: '*',
      element: <Navigate to="/404" replace />,
    },
  ]);

  return routes;
}